import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const closeInvoice = (invoice) => apiActionCreator({
  'endpoint': `/storageProcesses/invoices/${invoice}/storageClosure`,
  'authenticated': true,
  'types': [
    ActionTypes.CLOSING_INVOICE,
    [
      {
        'type': ActionTypes.CLOSED_INVOICE,
        'payload': invoice,
      },
      MessageActions.addMessageBoxInfo(`La factura ${invoice} ha sido cerrada satisfactoriamente`),
    ],
    [
      ActionTypes.CLOSED_INVOICE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
});
